<div class="inspection-container">
  <app-inspection-side-contents
    (imageUpload)="uploadedProcess()"
    (updateInspection)="updateInspection($event)"
    (addReport)="openNewInspectionReportDialog()"
    [generatedReportTree]="this.generatedReportTree"
    [historyReports]="this.historyReports"
    [inspectionImagesCount]="inspectionImagesCount$ | async"
    [inspection]="this.inspection"
    [isReadOnly]="isReadOnly()"
    [isReportLoading]="isReportLoading"
    [pastReportFilter]="pastReportFilter"
    [report]="this.report"
    [sideNavType]="this.sidenavType"
    [subjectModel]="this.inspectionState.model()"
    [inspectionReport]="report"
  />

  <app-inspection-data-management
    (clickedReportSetting)="openNewInspectionReportDialog()"
    (updateInspection)="updateInspection($event)"
    *ngIf="!isReportView && inspection"
    [closedMenuWidth]="closedMenuWidth"
    [expand]="!this.sideNavOpened"
    (uploadInspectionImage)="dataUpload()"
    (editInspectionInfo)="openEditModal()"
    [inspectionReport]="report"
    [inspection]="inspection"
    [marks]="marks"
    [openedMenuWidth]="openedMenuWidth"
    [scrollTop]="scrollTop"
    [selectedLocation]="selectedLocation"
    [subjectModel]="this.inspectionState.model()"
    [subjects]="liveAssetsState.liveAssets()"
    [tags]="tags"
    [titles]="titles"
    [uploadedEvent]="onUploaded$"
    class="images"
  />

  <app-inspection-report
    (changedReport)="onChangedReportId($event)"
    (previewGenerated)="onPreviewGenerated($event)"
    *ngIf="isReportView"
    [inspectionReport]="report"
    [inspection]="inspection"
    [pdfUrl]="pdfUrl"
    class="report"
  />
</div>
